import "./SpinLoadingIndicator.css";

export default function SpinLoadingIndicator() {
    const strokeWidth = 12;
    return (
        <svg fill="none" viewBox="0 0 66 66" className="w-7 mx-auto">
            <circle
                cx="33"
                cy="33"
                fill="none"
                r="28"
                stroke="white"
                strokeDasharray="1, 174"
                strokeDashoffset="306"
                strokeLinecap="round"
                strokeWidth={strokeWidth}
                style = {{
                    animation: "spinner-animation 1.5s linear infinite"
                }}
            />
        </svg>
    );
}